// removed by extract-text-webpack-plugin
module.exports = {"input":"style-input__input___28w0F","large":"style-input__large___2sGsF","fill":"style-input__fill___1nHnJ","suggestionsContainer":"style-input__suggestionsContainer___8E3SI","suggestion":"style-input__suggestion___1MQ_1","suggestionHighlighted":"style-input__suggestionHighlighted___G-RU5"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/style-input/style-input.scss
// module id = 223
// module chunks = 0 1